import { BaseService } from '../../../../../core/services/base.service';
import {
  CandidateMatchChatRequest,
  CandidateMatchChatResponse,
  CandidateMatchRequest,
  CandidateMatchResponse,
} from '../models/candidate-match.model';

export class CandidateMatchService {
  static Search(
    companyId: string,
    request: CandidateMatchRequest
  ): Promise<CandidateMatchResponse> {
    return BaseService.Post(
      `/companies/${companyId}/candidate-matches`,
      request,
      undefined,
      (error: Error) => {
        throw error;
      },
      false
    );
  }

  static Chat(
    companyId: string,
    request: CandidateMatchChatRequest
  ): Promise<CandidateMatchChatResponse> {
    return BaseService.Post(
      `/companies/${companyId}/candidate-matches/chat`,
      request,
      undefined,
      (error: Error) => {
        throw error;
      },
      false
    );
  }
}
